import React from 'react';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import { IItemWithoutShowSellerProps } from './IItemProps';
import CdNumberInput from '../CdNumberInput.styles';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { IPersonalPropertySaleViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface IPersonalPropertySaleProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<IPersonalPropertySaleViewItem>,
    IHasItemEventProps<IPersonalPropertySaleViewItem> {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

export default class PersonalPropertySale extends React.Component<IPersonalPropertySaleProps> {
  constructor(props: IPersonalPropertySaleProps) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const buyerAtClosingOnChangeEvent = createOnChangeHandlerGenerator(data, onChange)('buyer_at_closing');
    return (
      <div className="cost-data__row cost-data__aligned-row">
        <span className="cost-data__content-cell cost-data__content-row-number" />
        <span className="cost-data__content-cell cost-data__content-name">
          Sale Price of Any Personal Property Included in Sale
        </span>
        <span className="cost-data__content-cell cost-data__content-amount">
          <CdNumberInput
            mode="currency"
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onChange={buyerAtClosingOnChangeEvent}
            value={this.props.data.buyer_at_closing}
            readOnly={!hasEditPermissions}
            debounceOnValueChange
          />
        </span>
        <span className="cost-data__content-cell cost-data__content-control" />
      </div>
    );
  }

  private onBlur(event: React.FocusEvent) {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur(event);
    }
  }

  private onFocus() {
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus();
    }
  }
}
